module.exports = "<!-- Begin page -->\n<div class=\"wrapper\"> \n  <div class=\"page-reporte\">\n    <div class=\"content\">\n      <img class=\"card-img-top\" *ngIf=\"comprobanteImage\" [src]=\"comprobanteImage\">\n      <a *ngIf=\"comprobanteImage\" [href]=\"comprobanteImage\">Descargar</a>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reporte-liquidacion-comprobante-imagen/reporte-liquidacion-comprobante-imagen.component.html
// module id = ./src/app/components/reporte-liquidacion-comprobante-imagen/reporte-liquidacion-comprobante-imagen.component.html
// module chunks = main